module.exports = __webpack_public_path__ + "static/img/amex.f056efa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cards/amex.svg
// module id = JXDf
// module chunks = 1